import { Link } from "react-router-dom";
import { useApp } from "../../context/AppContext";
import { money, fileUrl } from "../../lib/api";

export default function ProductCard({ p, i = 0 }) {
  const { locale, t } = useApp();
  return (
    <Link to={`/product/${p.id}`} data-testid={`product-card-${p.id}`} className="group block rise" style={{ animationDelay: `${(i % 12) * 40}ms` }}>
      <div className="aspect-[4/5] overflow-hidden bg-[#14161D] relative">
        <img src={fileUrl(p.image, 600)} alt={p.title} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        {!p.available && <span className="absolute top-3 left-3 bg-black/80 text-[10px] font-mono uppercase tracking-widest px-2 py-1">{p.unavailable_reason || t("unavailable")}</span>}
      </div>
      <div className="pt-4 flex justify-between gap-3">
        <div>
          <div className="label-xs">{p.category}</div>
          <div className="text-sm mt-1 group-hover:text-[#C9A96E] transition-colors">{p.title}</div>
        </div>
        <div className="font-mono text-sm whitespace-nowrap" data-testid={`product-price-${p.id}`}>{p.price_from ? (locale.lang === "fr" ? "Dès " : "From ") : ""}{money(p.price, p.currency, locale.lang)}</div>
      </div>
    </Link>
  );
}
